module.exports = "/_next/static/images/EnsureCustomerData@2x-cb755504b489d6e59f65e8504291f6f3.png";